<!-- 供应余量表 -->
<template>
  <ls-table-layout>
    <div slot="search">
      <div class="supply-margin-title">供应余量检视表参数：</div>
      <a-form :form="form" style="width: 600px;" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="MPS版本">
          <global-select
            v-decorator="['version', { rules: [{ required: true, message: '请选择MPS版本' }] }]"
            requestApi="/scp/scpMpsPlans/suppliesRemainVersion"
            :selectItem="{ value: 'realValue', label: 'label' }"
          />
        </a-form-item>
        <a-form-item label="货审提前期">
          <div style="display: flex; align-items: center">
            <a-input v-decorator="['earlyDay', { rules: [{ required: true, message: '请选择货审提前期' }] }]" type="number" />
            <span style="margin-left: 5px;">天</span>
          </div>
        </a-form-item>
        <a-form-item label="零星需求起始日期">
          <a-input v-decorator="['sporadicDay']" type="number" />
        </a-form-item>
        <a-form-item label="项目组">
          <global-select
            v-decorator="['projectTeams']"
            selectType="selectMultiple"
            requestApi="/scp/scpMpsPlans/projectTeam"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :setParams="{ pageSize: 9999 }"
          />
        </a-form-item>
        <a-form-item label="主型号">
          <a-input v-decorator="['mainModel']" />
        </a-form-item>
        <a-form-item label="物料编码">
          <global-select
            v-decorator="['itemCodes']"
            :dropdown-match-select-width="false"
            selectType="selectAssembleMultipleSearch"
            requestApi="/scp/scpMpsPlans/listItemCodeCp"
            :assembleLabel="true"
            :selectItem="{ value: 'selectedValue', label: 'selectedValue', thirdLabel: 'bringOutDataOne' }"
            searchParam="itemCode" />
        </a-form-item>
      </a-form>
      <div class="supply-margin-btn">
        <a-button type="primary" @click="handleReset">重置</a-button>
        <a-button type="primary" @click="handleExport">导出</a-button>
      </div>
      <download-modal :apiFun="apiScpExportSuppliesRemain" ref="download" />
    </div>
  </ls-table-layout>
</template>

<script>
import { apiScpExportSuppliesRemain } from '@/api/report/supply-margin.js'
import { mapState } from 'vuex'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'

export default {
  // eslint-disable-next-line
  name: 'Supply-margin', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode,
      cacheHistory: (state) => state.pageHistory.cashHistory
    })
  },
  data() {
    return {
      apiScpExportSuppliesRemain,
      form: this.$form.createForm(this)
    }
  },
  created() {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      const cachedData = this.cacheHistory[this.$route?.fullPath]
      this.$nextTick(() => {
        if (this.form) {
          this.form.setFieldsValue({ ...cachedData })
        }
      })
    }
  },
  mounted() {
  },
  methods: {
    /** 重置按钮操作 */
    handleReset() {
      this.form.resetFields()
    },
    // 导出
    handleExport () {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = this.form.getFieldsValue()
          this.$store.commit('setCashHistory', { path: this.$route.fullPath, data: cloneDeep(params) })
          this.$refs.download.openModal(params)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.supply-margin-title {
  font-size: 20px;
  font-weight: bolder;
}
.supply-margin-btn {
  width: 400px;
  display: flex;
  justify-content: space-around;
  padding-bottom: 20px;
}
</style>
